import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Modal, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { GuardarDireccion, ObtenerDirecciones } from '../../helpers/DireccionesHelper';
import { GuardarUsuario } from '../../helpers/UsuariosHelper';
import { DireccionesContext } from '../../pages/catalogos/DireccionesPage';
import { UsuariosContext } from '../../pages/catalogos/UsuariosPage';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregarDireccionComponent = () => {
    const {modalAgregaDireccion, setModalAgregaDireccion, obtenerDirecciones, usuarios, editandoDireccion, direccionSeleccionada} = useContext(DireccionesContext);
    const [formDireccion, setFormDireccion] = useState({});
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [direcciones, setDirecciones] = useState([]);
    const [opcionesDireccion, setOpcionesDireccion] = useState([]);
    const [defaultResponsable, setDefaultResponsable] = useState();
    const [idResponsable, setIdResponsable] = useState();
    const refResponsable = useRef();
    const handleClose = () => {
        setModalAgregaDireccion(false);
        setFormDireccion({})
    }

    const verificaAccion= () => {
      console.log('verificando accion', direccionSeleccionada)
      if(direccionSeleccionada?.idDireccion) {
        console.log('Se esta editando la direccion', direccionSeleccionada)
        setFormDireccion({
          ...formDireccion,
          idDireccion:direccionSeleccionada.idDireccion,
          direccion:direccionSeleccionada.direccion,
          nombreCorto:direccionSeleccionada.nombreCorto,
          idResponsable:direccionSeleccionada.idResponsable
        })
        //refResponsable.current.value=direccionSeleccionada.responsable
    //    console.log('ref responsable', refResponsable.current)
      } else {
        console.log('Se esta agregando direccion')
      }
    }

    useEffect(() => {
      verificaAccion();
   //   console.log('ref responsable valor', refResponsable.current.value)
      //refResponsable.current.
    }, [direccionSeleccionada])
    


    console.log('usuarios recibidos en modal agregar direccion', usuarios)

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
        GuardarDireccion(formDireccion).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerDirecciones();
                handleClose();

            }
        })
    }




    useEffect(() => {
      obtenerDirecciones().then(() => {

        const resp = usuarios.findIndex((usuario) => usuario.Usuarios_IdUsuario == direccionSeleccionada?.idResponsable )
        console.log('responsable en arreglo', resp, usuarios[resp]);
        setDefaultResponsable(usuarios[resp]);
      })
     // refResponsable.current.setState({usuarios[resp]});
    }, [])
    
    // useEffect(() => {
    //   obtenerDirecciones();
    //   if(editandoDireccion) {
    //     console.log('editando direccion')
    //     setFormDireccion(direccionSeleccionada)
    //     console.log('refResponsable', refResponsable)
    //   }
    // }, [editandoDireccion])
    
    useEffect(() => {
      console.log('usuarios en agrega direccion', usuarios, 'Editando direccion',editandoDireccion);
     // setDirecciones([]);
      let opcionesU = new Array();
        usuarios?.map(usuario => {
          opcionesU = ([...opcionesU, {value:usuario.IdUsuario, label:(usuario.Nombre+' '+usuario.ApellidoPaterno)}])
      })    
      setOpcionesDireccion(opcionesU);
  

    }, [])

    
    

    const actualizaDireccion = (dato, valor) => {
      setFormDireccion({
        ...formDireccion,
        [dato]:valor
      })
    }

    useEffect(() => {
      console.log('formulario direccion', formDireccion);
    }, [formDireccion])
    

     useEffect(() => {
       console.log('opciones direccion', opcionesDireccion);
     }, [opcionesDireccion])

     const handleChange = (event) => {
      console.log('responsable seleccionado', event)
    };

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaDireccion} onClose={handleClose}>
        <form onSubmit={handleSubmit} >
        <DialogTitle>Dirección</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Dirección"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            InputLabelProps={{ shrink: true }} 
            onChange={(e) => actualizaDireccion('direccion',e.target.value)}
            value={formDireccion?.direccion}
          />
          <TextField
            style={{
              marginBottom:20
            }}
            margin="dense"
            label="Nombre Corto"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            InputLabelProps={{ shrink: true }} 
            onChange={(e) => actualizaDireccion('nombreCorto',e.target.value)}
            value={formDireccion?.nombreCorto}
          />
      <FormControl variant='standard' fullWidth>
        <InputLabel id="demo-simple-select-label">Responsable</InputLabel>
        <Select
          ref={refResponsable}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={formDireccion?.idResponsable}
          label="Responsable"
          defaultValue={direccionSeleccionada?.idResponsable || -1}
          onChange={(event) => {console.log(event);setIdResponsable(event.target.value);actualizaDireccion('idResponsable', event.target.value)}}
          //onSelect={(event => handleChange(event))}
        >
          {
            usuarios?.map(usuario => (
              <MenuItem key={usuario.IdUsuario} value={usuario.IdUsuario}>{usuario.Nombre+' '+usuario.ApellidoPaterno}</MenuItem>
            ))
          }
        </Select>
      </FormControl>

          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
